/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetsItemResource } from '../models/AssetsItemResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetsItemService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les assets
     * Les contenus configurables par defaut (`name`, `description`, `type_id`, `place_holders`, `validation`), que chaque entreprise peut ensuite personnaliser.
     * @returns AssetsItemResource Array of `AssetsItemResource`
     * @throws ApiError
     */
    public adminAssetsitemIndex(): CancelablePromise<Array<AssetsItemResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetsitem',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Creer un asset
     * `name`, `description`, `type_id`, `place_holders` (variables disponibles) et `validation` (regles appliquees aux valeurs personnalisees).
     * @param requestBody
     * @returns AssetsItemResource `AssetsItemResource`
     * @throws ApiError
     */
    public adminAssetsitemStore(
        requestBody: {
            name: string;
            description?: string | null;
            type_id?: number;
            content: string;
            validation: string;
        },
    ): CancelablePromise<AssetsItemResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/assetsitem',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un asset
     * Avec son type.
     * @param id
     * @returns AssetsItemResource `AssetsItemResource`
     * @throws ApiError
     */
    public adminAssetsitemShow(
        id: string,
    ): CancelablePromise<AssetsItemResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetsitem/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un asset
     * Mise a jour partielle.
     * @param id
     * @param requestBody
     * @returns AssetsItemResource `AssetsItemResource`
     * @throws ApiError
     */
    public adminAssetsitemUpdate(
        id: string,
        requestBody?: {
            name?: string;
            description?: string;
            type_id?: number;
            content?: string;
            validation?: string;
        },
    ): CancelablePromise<AssetsItemResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/assetsitem/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un asset
     * Avec ses personnalisations par entreprise.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminAssetsitemDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/assetsitem/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
